/**
 * Delays execution of a callback or returns a promise resolving after a delay.
 * If a callback is provided, executes it after the specified delay and returns a cancellation function.
 * If no callback is provided, returns a promise that resolves after the specified delay.
 *
 * @param {function} [callback] - Optional. The callback function to execute after the delay.
 * @param {number} timer - The delay in milliseconds.
 * @returns {function|Promise} Returns a cancellation function if a callback is provided, or a Promise if no callback is provided.
 */
export function delay({ callback, timer = 0 }) {
    if (typeof timer !== 'number' || timer < 0) {
        throw new Error('Invalid delay parameter');
    }

    if (typeof callback === 'function') {
        const timeoutId = setTimeout(callback, timer);

        const cancel = () => clearTimeout(timeoutId);

        return cancel;
    } else if (callback === undefined) {
        return new Promise(resolve => setTimeout(resolve, timer));
    } else {
        throw new Error('Invalid arguments: callback must be a function or undefined');
    }
}
